import React, { useState } from 'react';
import Draggable, { DraggableData, DraggableEvent } from 'react-draggable';

const DragPopover: React.FC<{
    draggleRef: React.RefObject<HTMLDivElement>;
}> = React.memo(({ draggleRef, children }) => {
    const ignoreDragClass = ['.color-gradient-select', '.c-color-sketch-picker__menu--input', '.mt-input-number'];

    const [bounds, setBounds] = useState({
        left: 0,
        top: 0,
        bottom: 0,
        right: 0,
    });
    // const draggleRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const { clientWidth, clientHeight } = window.document.documentElement;
        const targetRect = draggleRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top + uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        });
    };

    return (
        <div
            onMouseDown={(e) => {
                e.stopPropagation();
                e.preventDefault?.();
            }}
        >
            <Draggable
                enableUserSelectHack={false}
                disabled={false}
                bounds={bounds}
                onStart={(event, uiData) => {
                    const hasIncludeDom = ignoreDragClass.find(
                        (d) =>
                            Array.from(document.querySelectorAll(d)).filter((d) =>
                                d?.contains(event.target as HTMLElement | null),
                            ).length > 0,
                    );
                    return hasIncludeDom ? false : onStart(event, uiData);
                }}
            >
                {children}
            </Draggable>
        </div>
    );
});

export default DragPopover;
